<template>
  <main class="main" v-if="getUserData.personality">
    <div class="anim-wrap">
      <div class="container">
        <div class="row">
          <div class="col-md-5">
            <PersonalityUserCard
              :firstName="getUserData.firstName"
              :lastName="getUserData.lastName"
              :personality="getUserData.personality"
            />
            <div
              v-if="
                !getUserData.personalityFeedback &&
                  getUserData.personalityFeedback !== 0
              "
              class="sheet-panel feedback-panel"
            >
              <div class="sheet-header">
                <h3>How would you rate your report?</h3>
              </div>
              <div class="sheet-content text-center">
                <div class="row">
                  <div class="col-4 offset-2" v-if="!givenFeedback">
                    <button
                      class="btn-feedback positive"
                      title="Accurate"
                      @click="giveFeedback(1)"
                      v-tippy
                    >
                      <font-awesome-icon icon="thumbs-up" />
                    </button>
                  </div>
                  <div class="col-4" v-if="!givenFeedback">
                    <button
                      class="btn-feedback negative"
                      title="Inaccurate"
                      @click="giveFeedback(0)"
                      v-tippy
                    >
                      <font-awesome-icon icon="thumbs-down" />
                    </button>
                  </div>
                  <div class="col-12" v-if="givenFeedback">
                    <h3 style="padding: 20px">Thanks for your feedback!</h3>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="
                getUserData.personalityFeedback ||
                  getUserData.personalityFeedback == 0
              "
              class="panel content-panel blue-panel light pad-medium hidden-sm"
            >
              <h3>Invite your friends</h3>
              <p>
                Invite your friends and compare your reports.
              </p>
              <button
                @click="$toggleFriendsModal()"
                type="button"
                class="btn btn-medium btn-primary"
              >
                <span>Invite friends</span>
              </button>
            </div>
          </div>
          <div class="col-md-7">
            <PersonalitySplitCard :personality="getUserData.personality" />
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <PersonalityCareerCard
              :personality="getUserData.personality"
              :psiccDescriptions="getUserData.psiccDescriptions"
            />
          </div>
        </div>

        <!-- <div class="row">
          <div class="col-12">
            <PersonalityTopJobsCard :topOccupationsProp="getUserData.topOccupations" />
          </div>
        </div> -->

        <div class="row">
          <div class="col-12">
            <PersonalityHighsAndLowsCard
              :personality="getUserData.personality"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <PersonalityTraitCard
              :personality="getUserData.personality"
              :psiccDescriptions="getUserData.psiccDescriptions"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <PersonalityCompareCard />
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
// FireBase
import { db } from "../main.js";

import { mapState } from "vuex";

import PersonalityUserCard from "@/components/PersonalityUserCard";
import PersonalitySplitCard from "@/components/PersonalitySplitCard";
import PersonalityHighsAndLowsCard from "@/components/PersonalityHighsAndLowsCard";
import PersonalityCareerCard from "@/components/PersonalityCareerCard";
import PersonalityTraitCard from "@/components/PersonalityTraitCard";
//import PersonalityTopJobsCard from "@/components/PersonalityTopJobsCard";
import PersonalityCompareCard from "@/components/PersonalityCompareCard";

export default {
  name: "results",
  components: {
    PersonalityUserCard,
    PersonalitySplitCard,
    PersonalityHighsAndLowsCard,
    PersonalityCareerCard,
    PersonalityTraitCard,
    //PersonalityTopJobsCard,
    PersonalityCompareCard,
  },
  computed: {
    ...mapState(["user"]),
    ...mapState(["userData"]),
    getUser() {
      return this.user ? this.user : "";
    },
    getUserData() {
      return this.userData ? this.userData : "";
    },
  },
  data() {
    return {
      givenFeedback: false,
    };
  },
  mounted() {
    if (!this.getUserData.personality) {
      this.$router.replace("/");
    }
  },
  methods: {
    giveFeedback(feedback) {
      if (this.givenFeedback) {
        return true;
      }
      const userData = this.getUser;
      const uid = userData.uid;
      let data = { personalityFeedback: feedback };

      if (uid) {
        this.givenFeedback = true;
        setTimeout(() => {
          db.collection("users")
            .doc(uid)
            .update(data)
            .then(() => {})
            .catch((err) => {
              this.$toast.open({
                message: err.message,
              });
              this.loading = false;
            });
        }, 1500);
      }
    },
  },
};
</script>
